// DO NOT MODIFY THIS FILE
// Generated by bin/generate_feature_flags_v2.py
import { graphql } from 'react-relay';

graphql`
  fragment featureFlagsV2 on FeatureFlagsV2 @relay(mask: false) {
    canAccessNewDistrictReport
    canAccessNewDistrictReportImpact
    canAccessNewDistrictReportSchoolLevel
    canAccessNewDistrictReportTemplates
    canPreviewProblemEventDataInSkills
    catfaEnableSecondarySaveAsTemplate
    checkinsEnableDiscoveryCheckinCapGrades
    classSkillsReportCurriculumEnableGrowth
    devGetProblemEventsBackgroundRequestsPerMinuteLimit
    devSkillsReportEnableTimeFilter
    enableAiOpenPrompt
    enableAiPremiumTrial
    enableAiSuggestQuestions
    enableTestMode
    gamificationEnableBackgroundsAndAvatars
    gamificationEnableChallengesDaily
    gamificationEnableInlineLeaderboardNotification
    gamificationEnableLeaderboardClassSelectionPrompt
    gamificationEnableLeaderboardDock
    gamificationEnableLeaderboardModalV2
    gamificationEnableLeaderboardNotification
    gamificationEnableLeaderboardTab
    gamificationEnableLiveModePromote
    gamificationEnableMonthlyExpedition
    gamificationEnablePointsCheckins
    gamificationEnableQuestionSuccessBannerV2
    gamificationEnableShop
    gamificationEnableStudentDashboardV2
    gamificationEnableTeacherStickers
    gamificationEnableTugOfWar
    gamificationEnableWeeklyPBHeader
    gamificationHighlightStreaksInWorkbookHeader
    globalSearchEnableMVP
    graphqlEnableNodeResolver
    perfUpdateIndirectMasteryAsync
    preTopicTestCheckInCanAccess
    printEnablePageBreaksAfterPTs
    prototypeEnableWorksheetChat
    reportsEnableRecommendTasks
    showMaintenanceBanner
    showWorkbookOnboarding
    skillsActivityReportEnableOutcomeFilter
    skillsActivityReportEnableSubstrandFilter
    skillsAlchemyGradeLevelA13
    skillsShowGradeLevelOverride
    studentSkillsReportsEnableProblemEventData
    supportEnableHubspotBubble
    teacherOnboardingExperiment
    topicTestsEnableMVP
    workbookEnableDesmosCalculators
    workbookEnableSpanishSupport
  }
`;
export const FEATURE_FLAG_V2_DEFAULTS_FOR_TEST_MOCKS = {
  canAccessNewDistrictReport: false,
  canAccessNewDistrictReportImpact: false,
  canAccessNewDistrictReportSchoolLevel: false,
  canAccessNewDistrictReportTemplates: false,
  canPreviewProblemEventDataInSkills: false,
  catfaEnableSecondarySaveAsTemplate: false,
  checkinsEnableDiscoveryCheckinCapGrades: false,
  classSkillsReportCurriculumEnableGrowth: false,
  devGetProblemEventsBackgroundRequestsPerMinuteLimit: 'N1000',
  devSkillsReportEnableTimeFilter: false,
  enableAiOpenPrompt: false,
  enableAiPremiumTrial: false,
  enableAiSuggestQuestions: false,
  enableTestMode: false,
  gamificationEnableBackgroundsAndAvatars: false,
  gamificationEnableChallengesDaily: false,
  gamificationEnableInlineLeaderboardNotification: false,
  gamificationEnableLeaderboardClassSelectionPrompt: false,
  gamificationEnableLeaderboardDock: false,
  gamificationEnableLeaderboardModalV2: false,
  gamificationEnableLeaderboardNotification: false,
  gamificationEnableLeaderboardTab: false,
  gamificationEnableLiveModePromote: false,
  gamificationEnableMonthlyExpedition: false,
  gamificationEnablePointsCheckins: false,
  gamificationEnableQuestionSuccessBannerV2: false,
  gamificationEnableShop: false,
  gamificationEnableStudentDashboardV2: false,
  gamificationEnableTeacherStickers: false,
  gamificationEnableTugOfWar: false,
  gamificationEnableWeeklyPBHeader: false,
  gamificationHighlightStreaksInWorkbookHeader: false,
  globalSearchEnableMVP: false,
  graphqlEnableNodeResolver: false,
  perfUpdateIndirectMasteryAsync: false,
  preTopicTestCheckInCanAccess: false,
  printEnablePageBreaksAfterPTs: false,
  prototypeEnableWorksheetChat: false,
  reportsEnableRecommendTasks: false,
  showMaintenanceBanner: false,
  showWorkbookOnboarding: false,
  skillsActivityReportEnableOutcomeFilter: false,
  skillsActivityReportEnableSubstrandFilter: false,
  skillsAlchemyGradeLevelA13: false,
  skillsShowGradeLevelOverride: false,
  studentSkillsReportsEnableProblemEventData: false,
  supportEnableHubspotBubble: false,
  teacherOnboardingExperiment: 'NONE',
  topicTestsEnableMVP: false,
  workbookEnableDesmosCalculators: false,
  workbookEnableSpanishSupport: false,
} as const;
